import { application } from "./application"

import ClipboardController from "./clipboard_controller"
import DismissableController from "./dismissable_controller"
import ModalController from "./modal_controller"
import SandboxController from "./sandbox_controller"
import SandboxKeyController from "./sandbox_key_controller"
import UsageChartController from "./usage_chart_controller"
import SpendingLimitFormController from "./spending_limit_form_controller"
import PreciosCalculatorController from "./precios_calculator_controller"
import DictionaryFilterController from "./dictionary_filter_controller"
import RevealAnchorController from "./reveal_anchor_controller"
import PasswordToggleController from "./password_toggle_controller"
import LandingDemoController from "./landing_demo_controller"

application.register("clipboard", ClipboardController)
application.register("dismissable", DismissableController)
application.register("modal", ModalController)
application.register("sandbox", SandboxController)
application.register("sandbox-key", SandboxKeyController)
application.register("usage-chart", UsageChartController)
application.register("spending-limit-form", SpendingLimitFormController)
application.register("precios-calculator", PreciosCalculatorController)
application.register("dictionary-filter", DictionaryFilterController)
application.register("reveal-anchor", RevealAnchorController)
application.register("password-toggle", PasswordToggleController)
application.register("landing-demo", LandingDemoController)
